module.exports = __webpack_public_path__ + "img/artboard–6.aad0e478.png";